import { Geist, Geist_Mono, Space_Mono } from "next/font/google";

export { baseURL } from "./site-url";

const primaryFont = Geist({
    variable: "--font-geist-sans",
    subsets: ["latin"],
    display: "swap",
});

const monoFont = Geist_Mono({
    variable: "--font-geist-mono",
    subsets: ["latin"],
    display: "swap",
});

const spaceMonoFont = Space_Mono({
    variable: "--font-space-mono",
    subsets: ["latin"],
    weight: ["400", "700"],
    display: "swap",
});

export const font = {
    primary: primaryFont,
    code: monoFont,
    spaceMono: spaceMonoFont,
};
